import auth from './auth';
import administration from './administration';
import firmwares from './firmwares';
import jobs from './jobs';
import rules from './rules';
import stbGroups from './stbGroups';
import systemHints from './systemHints';
import devices from './devices';
import version from './version';
import batchMove from './batchMove';
import reports from './reports';
import actionHistory from './actionHistory';
import rescue from './rescue';
import tags from './tags';

export const API_URL = 'http://localhost:8080/api';

const api = {
  auth,
  administration,
  firmwares,
  jobs,
  rules,
  stbGroups,
  systemHints,
  devices,
  version,
  batchMove,
  actionHistory,
  reports,
  rescue,
  tags,
};

export default api;
